//在这个文件中根路由 / 必须定义，children可自定义
const _import = require("../_import_" + process.env.NODE_ENV);

const routes = [
  {
    path: "/",
    name: "Login",
    component: _import("Login"),
    meta: {
      parent: 0,
    },
    children: [
      {
        path: "/workList",
        name: "workList",
        component: _import("workDynamic/workList"),
        meta: {
          menuName: "资讯列表",
          index: 1, //面包屑顺序
        },
      },
      {
        path: "/workDetail",
        name: "workDetail",
        component: _import("workDynamic/workDetail"),
        meta: {
          menuName: "详情介绍",
          index: 2, //面包屑顺序
        },
      },
	  {
	    path: "/workDetail2",
	    name: "workDetail2",
	    component: _import("workDynamic/workDetail2"),
	    meta: {
	      menuName: "详情介绍",
	      index: 2, //面包屑顺序
	    },
	  },
    ],
  },
];
export default routes;
